import { ReactNode } from "react";

import { VnBox } from "@/components/VnBox";
import { I18nKeyType } from "@/i18n";

import { BottomNavigator } from "./BottomNavigator";
import { ScreenLayout } from "./ScreenLayout";

type CoverageEventsFlowStepWrapperPropsType = {
  children: ReactNode;
  onBack: () => void;
  onNext?: () => void;
  nextButtonI18nKey?: I18nKeyType;
  shouldShowNextButton?: boolean;
  isNextButtonLoading?: boolean;
  isNextButtonDisabled?: boolean;
};

// Wraps a step of a flow started from a coverage event (redeterminations, work
// requirements) with a scrollable content area and a fixed bottom navigator,
// mirroring the application flow layout.
export const CoverageEventsFlowStepWrapper = ({
  children,
  onBack,
  onNext,
  nextButtonI18nKey,
  shouldShowNextButton = true,
  isNextButtonLoading,
  isNextButtonDisabled,
}: CoverageEventsFlowStepWrapperPropsType) => (
  <VnBox className="bg-background h-full">
    <ScreenLayout
      className="mx-auto w-full max-w-lg gap-2 pt-6"
      backgroundClassName="bg-background">
      {children}
    </ScreenLayout>
    <BottomNavigator
      onBackButtonPress={onBack}
      onNextButtonPress={onNext}
      nextButtonI18nKey={nextButtonI18nKey}
      shouldShowNextButton={shouldShowNextButton}
      isNextButtonLoading={isNextButtonLoading}
      isNextButtonDisabled={isNextButtonDisabled}
    />
  </VnBox>
);
